import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "../lib/i18n";

const DEADLINE = new Date("2027-02-01T23:59:59-05:00");
const SHOW_WITHIN_DAYS = 75;

export const RsvpBanner = ({ onRsvp }) => {
  const { c } = useLang();
  const b = c.banner;
  const daysLeft = Math.ceil((DEADLINE - new Date()) / 86400000);
  const forced = new URLSearchParams(window.location.search).has("rsvpbanner");
  const inWindow = daysLeft >= 0 && daysLeft <= SHOW_WITHIN_DAYS;
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("pl-rsvp-banner") === "1");

  const dismiss = () => {
    sessionStorage.setItem("pl-rsvp-banner", "1");
    setDismissed(true);
  };

  const visible = (forced || inWindow) && !dismissed;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="rsvp-banner"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.7, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 z-50 sm:max-w-md"
        >
          <div className="flex items-center gap-4 bg-[#2C3552]/95 backdrop-blur-xl text-[#FAFAF1] border border-[#F4B8C6]/40 rounded-2xl sm:rounded-full pl-5 pr-3 py-3 shadow-2xl">
            <p className="flex-1 text-sm font-light leading-snug">
              <span className="font-serif-display italic text-[#F4B8C6]">{b.title}</span>{" "}
              {daysLeft >= 0 ? b.text.replace("{days}", daysLeft) : b.textNoDays}
            </p>
            <button
              data-testid="rsvp-banner-cta"
              onClick={() => {
                dismiss();
                onRsvp();
              }}
              className="shrink-0 text-[10px] uppercase tracking-[0.2em] px-4 py-2.5 rounded-full bg-[#E15A70] text-[#FAFAF1] hover:bg-[#FAFAF1] hover:text-[#2C3552] transition-colors duration-300"
            >
              {b.cta}
            </button>
            <button
              data-testid="rsvp-banner-dismiss"
              onClick={dismiss}
              aria-label="Dismiss"
              className="shrink-0 text-[#FAFAF1]/50 hover:text-[#FAFAF1] transition-colors duration-300 p-1"
            >
              <X size={16} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
